// Router
export const SET_CURRENT_PAGE = "ROUTER/SET_CURRENT_PAGE";
// Quiz
export const ADD_QUIZ_RESPONSE = "QUIZ/ADD_QUIZ_RESPONSE";
export const UNDO_QUIZ_RESPONSE = "QUIZ/UNDO_QUIZ_RESPONSE";
export const CLEAR_QUIZ = "QUIZ/CLEAR_QUIZ";
// Results
export const CALCULATE_RESULTS = "RESULTS/CALCULATE_RESULTS";
export const SET_ACTIVE_RESULT = "RESULTS/SET_ACTIVE_RESULT";
